import { render } from "./px-textarea.vue?vue&type=template&id=2ef7fe23&scoped=true&ts=true"
import script from "./px-textarea.vue?vue&type=script&lang=ts"
export * from "./px-textarea.vue?vue&type=script&lang=ts"

import "./px-textarea.vue?vue&type=style&index=0&id=2ef7fe23&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef7fe23"]])

export default __exports__